import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types/content';
import { formatRankChange } from '@/utils/content';

function changeColor(change?: number) {
  if (change === undefined) return 'text-foreground-500 bg-background-100';
  if (change > 0) return 'text-primary-700 bg-primary-50';
  if (change < 0) return 'text-accent-700 bg-accent-100';
  return 'text-foreground-600 bg-background-100';
}

export default function BlacklistCard({ item }: { item: ContentItem }) {
  const change = item.rankChange;
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 hover:border-primary-300 transition-colors h-full flex flex-col">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-11 h-11 rounded-md bg-primary-600 text-background-50 flex items-center justify-center text-lg font-black shrink-0">
            {item.player?.slice(0, 1)}
          </div>
          <div className="min-w-0">
            <Link
              to={`/detail/${item.id}`}
              className="block text-base font-bold text-foreground-950 hover:text-primary-700 transition-colors cursor-pointer truncate"
            >
              {item.player}
            </Link>
            <span className="text-xs text-foreground-500 truncate block">{item.team}</span>
          </div>
        </div>
        <span
          className={`px-2 py-1 rounded-md text-xs font-bold whitespace-nowrap ${changeColor(change)}`}
        >
          <i className="ri-arrow-down-line align-middle"></i>
          {formatRankChange(change)}
        </span>
      </div>

      <div className="flex items-center gap-2 mb-3 flex-wrap">
        <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-900 whitespace-nowrap">
          {item.event}
        </span>
        <span className="text-xs text-foreground-500 whitespace-nowrap">
          当前排名 No.{item.rank}
        </span>
      </div>

      <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">{item.reason}</p>

      <div className="mt-auto">
        <div className="flex items-center justify-between text-xs mb-1.5">
          <span className="text-foreground-500">关键表现指数</span>
          <span className="font-bold text-foreground-800">{item.performanceIndex}</span>
        </div>
        <div className="h-1.5 w-full rounded-full bg-background-200 overflow-hidden">
          <div
            className="h-full rounded-full bg-accent-500"
            style={{ width: `${item.performanceIndex || 0}%` }}
          ></div>
        </div>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
          <Link
            to={`/detail/${item.id}`}
            className="text-xs font-medium text-primary-700 hover:text-primary-800 flex items-center gap-0.5 cursor-pointer whitespace-nowrap"
          >
            查看详情
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}